/* eslint-disable no-underscore-dangle */
import EnumerationService from '../../services/EnumerationService';
import axios from 'axios';

const enedisCase = {
  state: {
    enums: {
      status: {
        tranche: [],
        trancheUpdate: [],
      },
    },
    enedisCaseList: null,
    enedisCaseOnGoing: null,
    caseManagerList: null,
    trancheStatusEnumeration: [],
    gaps: null,
    showGapHistoryTypeModal: null,
    showTrancheUpdateTypeModal: null,
  },
  mutations: {
    setEnums(state, value) {
      state.enums = value;
    },
    setEnedisCaseList(state, value) {
      state.enedisCaseList = value;
    },
    setEnedisCaseOnGoing(state, value) {
      state.enedisCaseOnGoing = value;
    },
    setCaseManagerList(state, value) {
      state.caseManagerList = value;
    },
    setTrancheStatusEnumeration(state, value) {
      state.trancheStatusEnumeration = value;
    },
    setGaps(state, value) {
      state.gaps = value;
    },
    setShowGapHistoryTypeModal(state, value) {
      state.showGapHistoryTypeModal = value;
    },
    setShowTrancheUpdateTypeModal(state, value) {
      state.showTrancheUpdateTypeModal = value;
    },
  },
  getters: {
    getEnums(state) {
      return state.enums;
    },
    getEnedisCaseList(state) {
      return state.enedisCaseList;
    },
    getEnedisCaseOnGoing(state) {
      return state.enedisCaseOnGoing;
    },
    getCaseManagerList(state) {
      return state.caseManagerList;
    },
    getTrancheStatusEnumeration(state) {
      return state.trancheStatusEnumeration;
    },
    getGaps(state) {
      return state.gaps;
    },
    getShowGapHistoryTypeModal(state) {
      return state.showGapHistoryTypeModal;
    },
    getShowTrancheUpdateTypeModal(state) {
      return state.showTrancheUpdateTypeModal;
    },
  },
  actions: {
    createGet(store, form) {
        return axios.post('enedis-cases', form)
            .then((response) => {
              // Code can be 200(already exit) or 201(created)
              EnumerationService.setEnums(store, {
                tranche: response.data._embedded.tranche_status_enumeration,
                trancheUpdate: response.data._embedded.tranche_update_status_enumeration,
              });
              store.commit('setTrancheStatusEnumeration', EnumerationService.getEnum(response.data._embedded.tranche_status_enumeration));

              return response;
            })
            .catch((error) => {
              console.error(error);
            });
    },
    getCaseManagers(store) {
      axios.get('case-managers')
          .then((response) => {
            store.commit('setCaseManagerList', response.data);

            return response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },
  },
};

export default enedisCase;



// WEBPACK FOOTER //
// ./src/store/modules/enedis-case.js